import React from "react";
import { Router, RouteComponentProps, Redirect } from "@reach/router";

import { Viewer } from "components/auth/types";

import NotFound from "pages/not-found";
import ProfilePage from "./pages/profile";
import ProfileAddressesPage from "./pages/profile/addresses";

type Props = {
  viewer: Viewer
} & RouteComponentProps;

const SettingsPage:React.FC<Props> = ({ viewer }) => (
  <Router primary={false}>
    <Redirect from="/" to="profile" noThrow />
    <ProfilePage path="profile" viewer={viewer} />
    <ProfileAddressesPage path="profile/addresses" viewer={viewer} />

    <NotFound default />
  </Router>
);

export default SettingsPage;
